var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"tags"},[_c('span',{staticClass:"badge",class:`is-${_vm.type}`},[(['light', 'info'].indexOf(_vm.type) < 0)?_c('span',{staticClass:"icon"},[_c('i',{staticClass:"fa-regular",class:_vm.icons[_vm.type]})]):_vm._e(),_c('span',[_vm._v(_vm._s(_vm.label))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }